import namespaces from "./namespaces";

export default function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/namespace.js
// module id = 566
// module chunks = 3